module.exports = __webpack_public_path__ + "img/out.c96b0e1d.svg";